<!--template html-->
<template>
    <div class="modal fade gt-md-modal" id="groupcard-print-modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered mt-0">
            <div class="modal-content">

                <div class="gt-md-modal-header">
                    <div class="gt-modal-back js-btn-step" data-orientation="previous">
                        <a href="javascript:void(0);" v-if="currentStep > 0 && currentStep < 3" @click="printNextStep(currentStep - 1)">
                            <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7 1L1 7L7 13" stroke="#1E2437" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </a>
                    </div>
                    <h2 v-if="currentStep > 0">Print professionally</h2>
                    <h2 v-else>Print</h2>
                    <div class="gt-modal-close" data-dismiss="modal">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" width="14" height="14">
                                <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 13 1 L 7 7 L 13 13" />
                                <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 1 13 L 7 7 L 1 1" />
                            </svg>
                    </div>
                </div>
                <!-- gt-md-modal-header -->

                <div v-show="currentStep==0" class="send-card-preview">
                    <div class="media align-items-center cursor-pointer hidden" @click="printNextStep(1)">
                        <img class="img-fluid" :src="$getAssetUrlPlugin('siteres/print-modal.png')" alt="" />
                        <div class="media-body">
                            <h5 class="mt-0">Print it professionaly</h5>
                            <p>Get your card delivered to your doorstep in 2-3 business days for only $20.</p>
                        </div>
                    </div>
                    <!-- media -->
                    <div class="media align-items-center cursor-pointer" @click="downloadCard">
                        <img class="img-fluid" :src="$getAssetUrlPlugin('siteres/print-modal.png')" alt="" />
                        <div class="media-body">
                            <h5 class="mt-0">Print it at home</h5>
                            <p>You can print your card at home for free at any time to show or send to friends.</p>
                        </div>
                    </div>
                    <!-- media -->
                </div>
                <!-- step 0 -->

                <div v-show="currentStep==1" data-step="1">
                    <div class="modal-image">
                        <img class="img-fluid" :src="$getAssetUrlPlugin('siteres/print-modal.png')" alt="Print" />
                    </div>
                    <div class="gt-md-modal-content">

                        <div class="row">
                            <div class="col-8">
                                <div class="form-group mt-form">
                                    <label for="">Who should we send it to?</label>
                                    <input type="text" class="form-control" id="full-name" v-model="printModal.Name" :class="{'group-card-error': !nameValid }" placeholder="Kirby Van">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group mt-form">
                                    <label for="">Amount</label>

                                    <div class="quantity modal-quantity d-flex justify-content-between align-items-center">
                                        <a href="javascript:void(0);" :class="printModal.Quantity==1?'quantity-blur':''" @click="setQuantity(1)">
                                            <i class="fas fa-minus"></i>
                                        </a>
                                        <input v-if="printModal.Quantity" type="text" id="gc-quantity" name="gc-quantity" v-model="printModal.Quantity">
                                        <a href="javascript:void(0);" :class="printModal.Quantity==2?'quantity-blur':''" @click="setQuantity(2)">
                                            <i class="fas fa-plus"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- row -->

                        <div class="row">
                            <div class="col-12">
                                <div class="form-group mt-form">
                                    <label for="">Delivery address</label>
                                    <input type="text" class="form-control" id="address-1" v-model="printModal.DeliveryAddress" placeholder="Enter address" @change="getAddress" :class="{'group-card-error': !addressValid1 }">
                                </div>
                            </div>
                        </div>
                        <!-- row -->

                        <div class="row">
                            <div class="col-12">
                                <div class="form-group mt-form">
                                    <div class="d-flex justify-content-between">
                                        <label for="">Delivery address for copy 2</label>
                                        <div class="modal-radio-block inline-radio-block">
                                            <label class="radio-label">
                                                Use same address
                                                <input type="checkbox" id="same-address-checkbox" v-model="printModal.SameAddress" @change="sameAddressChange">
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <input type="text" class="form-control lite-placeholder" id="address-2" v-model="printModal.DeliveryAddress2" placeholder="Enter address" @change="getAddress2" :disabled="isDisabled" :class="{'group-card-error': !addressValid2 }">
                                </div>
                            </div>
                        </div>
                        <!-- row -->

                        <div>
                            <a href="javascript:void(0);" class="theme-btn-lite js-btn-step" data-orientation="next" @click="printNextStep(2)">Next</a>
                        </div>
                        <!-- next button -->

                    </div>
                </div>
                <!-- step 1 -->

                <div v-show="currentStep==2" data-step="2">
                    <div class="gt-md-modal-content">

                        <div class="text-center gt-confirm-amount">
                            <h2>Confirm & pay</h2>
                            <p>${{printModal.TotalAmount}}</p>
                        </div>

                        <div class="modal-radio mb-4">

                            <div class="modal-radio-block">

                                <label class="radio-label">
                                    <span class="d-flex justify-content-between">
                                        <span>Pay with balance</span>
                                        <span class="active-balance">${{collectionAmount}}</span>
                                    </span>
                                    <input type="radio" v-model="paymentMode" name="add-card" value="1" :disabled="insufficientBalance">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <!-- modal-radio-block -->

                            <div class="modal-radio-block radius-zero">

                                <label class="radio-label">
                                    Pay with credit card
                                    <input type="radio" v-model="paymentMode" name="add-card" value="2">
                                    <span class="checkmark"></span>
                                </label>

                            </div>
                            <!-- modal-radio-block -->

                            <div class="modal-radio inline-radio pb-20">

                                <div class="row no-gutters mt-card-details" v-if="paymentMode==2">
                                    <label>Card details</label>
                                    <div class="col-12 d-flex justify-content-between">
                                        <input type="tel" class="form-control card-num" v-model="cc.CardNumber" :class="{'group-card-error': !ccNumberValid }" placeholder="1234 1234 1234 1234" data-custom-mask="CreditCard">
                                        <div class="payment-icons">
                                            <img :src="$getAssetUrlPlugin('siteres/visa-card.png')">
                                            <img :src="$getAssetUrlPlugin('siteres/master-card.png')">
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <input type="text" class="form-control card-expire" v-model="cc.ExpiryDate" :class="{'group-card-error': !ccDateValid }" placeholder="MM/YY" maxlength="5" data-custom-mask="CardExpiry">
                                    </div>
                                    <div class="col-6">
                                        <input type="tel" class="form-control card-cvc" v-model="cc.CVC" :class="{'group-card-error': !ccCVCValid }" placeholder="CVC" maxlength="3" data-custom-mask="CVV">
                                    </div>
                                </div>

                            </div>
                            <!-- inline-radio -->
                        </div>

                        <div>
                            <a href="javascript:void(0);" class="theme-btn-lite js-btn-step" data-orientation="next" @click="placeOrder">Place order</a>
                            <p v-if="errorMessage" style="color:red;">{{errorMessage}}</p>
                        </div>
                        <!-- next button -->
                    </div>
                </div>
                <!-- step 2 -->

                <div v-show="currentStep==3" data-step="3">
                    <div class="mt-order-completed text-center">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 58 56" width="58" height="56">
                            <path stroke="#36adb4" stroke-miterlimit="10" d="M 51 19 C 52.3 22.1 53 25.5 53 29 C 53 43.4 41.4 55 27 55 C 12.6 55 1 43.4 1 29 C 1 14.6 12.6 3 27 3 C 32.1 3 36.9 4.5 40.9 7" />
                            <path stroke="#36adb4" stroke-linecap="square" stroke-miterlimit="10" d="M 17 21 L 27 31 L 57 1" />
                        </svg>

                        <h1>Order complete!</h1>
                        <h2>Your order number is {{orderNumber}}</h2>
                        <p>You will receive an email confirmation with tracking information shortly</p>

                        <a :href="'/track/?collection=' + collection" class="theme-btn-lite">Back to my collection</a>
                        <!-- back button -->
                    </div>
                </div>
                <!-- step 3 -->

            </div>
        </div>
    </div>
    <!-- Print modal -->
</template>
<!--template html-->
<!--script -->
<script>

    export default {
        name: 'GroupCardPrintModal',
        components: {
        },
        props: {
            collection: String
        },
        data: function () {
            return {
                componentForm: {
                    subpremise: 'long_name',
                    street_number: 'short_name',
                    route: 'long_name',
                    locality: 'long_name',
                    administrative_area_level_1: 'short_name',
                    country: 'long_name',
                    postal_code: 'short_name'
                },
                printModal: {
                    Collection: "",
                    Name: "",
                    Quantity: 1,
                    SameAddress: false,
                    DeliveryAddress: "",
                    City: "",
                    Region: "",
                    PostCode: "",
                    DeliveryAddress2: "",
                    City2: "",
                    Region2: "",
                    PostCode2: "",
                    TotalAmount: 20,
                    CanAdd: false,
                    PaymentMode: 0
                },
                currentStep: 0,
                isDisabled: false,
                nameValid: true,
                addressValid1: true,
                addressValid2: true,
                pricePerCopy: 20,
                collectionAmount: 0,
                paymentMode: 2,
                insufficientBalance: true,
                cc: {
                    Collection: "",
                    CardNumber: "",
                    ExpiryDate: "",
                    CVC: "",
                    Amount: 0
                },
                errorMessage: "",
                ccNumberValid: true,
                ccDateValid: true,
                ccCVCValid: true,
                orderNumber: 0
            }
        },
        mounted: function () {
            this.printModal.Collection = this.collection
            this.cc.Collection = this.collection
        },
        methods: {
            async placeOrder() {
                console.log(this.printModal)
                this.printModal.PaymentMode = parseInt(this.paymentMode)
                //place order
                if (this.printModal.PaymentMode === 1) {
                    this.printModal.CanAdd = true
                    const requestOptions = {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(this.printModal)
                    };
                    await fetch('/api/collectionservices/placeprintorder', requestOptions)
                        .then((res) => res.json())
                        .then((data) => {
                            if (data.StatusCode === 1) {
                                this.currentStep = 3
                                this.orderNumber = data.OrderNumber
                            } else {
                                this.errorMessage = data.Message
                            }
                        })
                        .catch(err => console.log(err.message))
                }
                else {
                    //CC calidation
                    //checking number
                    if (!this.cc.CardNumber || this.cc.CardNumber === "") {
                        this.ccNumberValid = false
                    }
                    else {
                        this.ccNumberValid = true
                    }

                    //checking date
                    if (!this.cc.ExpiryDate || this.cc.ExpiryDate === "") {
                        this.ccDateValid = false
                    }
                    else {
                        this.ccDateValid = true
                    }

                    //checking cvc
                    if (!this.cc.CVC || this.cc.CVC === "") {
                        this.ccCVCValid = false
                    }
                    else {
                        this.ccCVCValid = true
                    }

                    if (this.ccNumberValid && this.ccDateValid && this.ccCVCValid) {
                        this.cc.Amount = this.printModal.TotalAmount
                        let pOrder = {
                            card: this.cc,
                            order: this.printModal
                        }
                        const requestOptions = {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify(pOrder)
                        };
                        await fetch('/api/collectionservices/ccpaymentprint', requestOptions)
                            .then((res) => res.json())
                            .then((data) => {
                                if (data.StatusCode === 1) {
                                    this.currentStep = 3
                                    this.orderNumber = data.OrderNumber
                                } else {
                                    this.errorMessage = data.Message
                                }
                            })
                            .catch(err => console.log(err.message))
                    }
                }
            },
            printNextStep(step) {
                //initial step to start the printing flow
                if (step === 1 || step === 0) {
                    this.currentStep = step
                    return true
                }

                //checking name
                if (!this.printModal.Name || this.printModal.Name === "") {
                    this.nameValid = false
                }
                else {
                    this.nameValid = true
                }

                //delivery address
                if (!this.printModal.DeliveryAddress || this.printModal.DeliveryAddress === "") {
                    this.addressValid1 = false
                }
                else {
                    this.addressValid1 = true
                }

                //delivery address 2
                if (this.printModal.Quantity === 2) {
                    if (!this.printModal.DeliveryAddress2 || this.printModal.DeliveryAddress2 === "") {
                        this.addressValid2 = false
                    }
                    else {
                        this.addressValid2 = true
                    }
                }

                //go to next step
                if (this.nameValid && this.addressValid1 && this.addressValid2) {
                    //if step 2 get latest collection amount
                    if (step === 2) {
                        this.getCollectionAmount()
                    }
                    this.currentStep = step
                }
            },
            setQuantity(quantity) {
                this.printModal.Quantity = quantity
            },
            sameAddressChange() {
                //assign address if true
                if (this.printModal.SameAddress) {
                    this.printModal.DeliveryAddress2 = this.printModal.DeliveryAddress
                    this.printModal.City2 = this.printModal.City
                    this.printModal.Region2 = this.printModal.Region
                    this.printModal.PostCode2 = this.printModal.PostCode
                    this.isDisabled = true
                }
                else {
                    this.printModal.DeliveryAddress2 = ""
                    this.printModal.City2 = ""
                    this.printModal.Region2 = ""
                    this.printModal.PostCode2 = ""
                    this.isDisabled = false
                }
            },
            getAddress() {
                const that = this
                //getting address from Google
                google.maps.event.addListener(autocomplete, 'place_changed', function () {
                    var place = autocomplete.getPlace();
                    var address = "";
                    for (var i = 0; i < place.address_components.length; i++) {
                        var addressType = place.address_components[i].types[0];
                        if (that.componentForm[addressType]) {
                            var val = place.address_components[i][that.componentForm[addressType]];
                            if (addressType == "locality" || addressType == "administrative_area_level_1" || addressType == "postal_code" || addressType == "country") {
                                //city
                                if (addressType === "locality") {
                                    that.printModal.City = val
                                }
                                //region
                                if (addressType === "administrative_area_level_1") {
                                    that.printModal.Region = val
                                }
                                //post code
                                if (addressType === "postal_code") {
                                    that.printModal.PostCode = val
                                }
                            }
                            else {
                                address += val + " ";
                            }
                        }
                    }
                    //assigning address
                    if (address.trim()) {
                        that.printModal.DeliveryAddress = address.trim()
                    }
                });
            },
            getAddress2() {
                const that = this
                //getting address from Google
                google.maps.event.addListener(autocomplete2, 'place_changed', function () {
                    var place = autocomplete2.getPlace();
                    var address = "";
                    for (var i = 0; i < place.address_components.length; i++) {
                        var addressType = place.address_components[i].types[0];
                        if (that.componentForm[addressType]) {
                            var val = place.address_components[i][that.componentForm[addressType]];
                            if (addressType == "locality" || addressType == "administrative_area_level_1" || addressType == "postal_code" || addressType == "country") {
                                //city
                                if (addressType === "locality") {
                                    that.printModal.City2 = val
                                }
                                //region
                                if (addressType === "administrative_area_level_1") {
                                    that.printModal.Region2 = val
                                }
                                //post code
                                if (addressType === "postal_code") {
                                    that.printModal.PostCode2 = val
                                }
                            }
                            else {
                                address += val + " ";
                            }
                        }
                    }
                    //assigning address
                    if (address.trim()) {
                        that.printModal.DeliveryAddress2 = address.trim()
                    }
                });
            },
            async getCollectionAmount() {
                await fetch('/track/tracksummary?collection=' + this.collection)
                    .then((res) => res.json())
                    .then(data => {
                        this.collectionAmount = data.TotalCollection
                    })
                    .catch(err => console.log(err.message))
            },
            downloadCard() {
                let url = "/groupcard/downloadpdf?collection=" + this.collection + "&backPage=0&privacy=false"
                window.open(url, '_blank').focus()
            }
        },
        watch: {
            'printModal.Quantity': function (newValue, oldValue) {
                this.printModal.TotalAmount = (newValue * this.pricePerCopy).toFixed(2)
            },
            collectionAmount: function (newValue, oldValue) {
                if (newValue < this.printModal.TotalAmount)
                    this.insufficientBalance = true
                else
                    this.insufficientBalance = false
            },
        }
    }
</script>
<!--script -->
<!--Add "scoped" attribute to limit CSS to this component only-->
<style scoped>
    .quantity-blur {
        background: rgba(54, 173, 180, 0.4);
    }

    .group-card-error {
        border: red 1px solid;
    }
</style>